import ReactDOM from "react-dom/client";
import "src/utils/initialization";
import "./assetRetryServiceWorker";
// TODO: importing routes from router, with routes.tsx nextdoor is confusing and unnecessary, and is left as an exercise to the reader to sort out.
import { routes } from "./router";
import { createHashRouter } from "react-router-dom";
import { SubscribedRouterProvider } from "./SubscribedRouterProvider";
import { getHashRouterPathRedirectUrl } from "src/utils/hashRouterPathRedirect";
import { LocaleGate } from "@web-monorepo/i18n";
import { Suspense } from "react";
import { logException } from "@classdojo/log-client";
import { coerceError } from "@web-monorepo/utilities";
import { showTranslationErrorNotification, TranslationsLoading } from "@web-monorepo/molecules";

const pathRedirectUrl = getHashRouterPathRedirectUrl({ location: window.location, pathPrefixes: ["/referrals"] });

if (pathRedirectUrl) {
  window.location.replace(pathRedirectUrl);
} else {
  // Opt into React Router v7 behavior (RR 6.30 warns until you do). These data-router flags are
  // behavioral no-ops here — the app routes by element + React Query (no page currently exports a
  // loader/action, no useFetcher/<Form>, no splat relative nav, no fallbackElement) — so they only
  // silence the warnings. v7_startTransition is intentionally left off: it defers URL updates and
  // breaks URL-driven state (see the teach pilot); the RR v7/v8 upgrade will use useTransitions={false}.
  // Matches teach/app/index.tsx.
  const router = createHashRouter(routes, {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  });

  const root = document.getElementById("root");
  if (!root) throw new Error("couldn't find #root element");

  // Translated text paints translated when the locale's catalog is in within the gate's grace
  // period, and nothing paints before then. A slower catalog gets the app in English meanwhile, with
  // a note saying translations are on their way. One that fails to load still renders the app: its
  // strings show in English, with a toast saying so, until a route's own load retries the catalog.
  // Marketplace has no session locale yet, so the gate uses the browser's.
  //
  // The failure is logged here because `LocaleGate` hands it to `onError` and swallows it: no
  // global unhandled-rejection handler will ever see it.
  ReactDOM.createRoot(root).render(
    <Suspense fallback={null}>
      <LocaleGate language={null} onError={reportCatalogError} pending={<TranslationsLoading />}>
        <SubscribedRouterProvider router={router} />
      </LocaleGate>
    </Suspense>,
  );
}

function reportCatalogError(error: unknown) {
  logException(coerceError(error), ["i18n", "activateLocale"]);
  showTranslationErrorNotification();
}
